/** Supply case fields used for the “(Case: ref - date - port - eta)” display line */
export type SupplyCaseForDisplay = {
  id?: number;
  ref?: string | null;
  caseDate?: string | null;
  eta?: string | null;
  port?: { name?: string | null; code?: string | null } | null;
};

/**
 * Returns parenthetical text: `(Case: ref - date - port - eta)` with em dashes for missing parts.
 */
export function formatCaseParenthetical(
  c: SupplyCaseForDisplay | null | undefined,
  formatDate: (iso?: string | null) => string,
): string | null {
  if (!c) return null;
  const ref = c.ref?.trim() || (c.id != null ? `Case #${c.id}` : '');
  const datePart = c.caseDate ? formatDate(c.caseDate) : '';
  const portPart = c.port?.name?.trim() || c.port?.code?.trim() || '';
  const etaPart = c.eta ? formatDate(c.eta) : '';
  return `(Case: ${ref} - ${datePart} - ${portPart} - ${etaPart})`;
}
